<script setup lang="ts">
  import Button from '@leaflink/stash/Button.vue';
  import Divider from '@leaflink/stash/Divider.vue';
  import Illustration from '@leaflink/stash/Illustration.vue';
  import Modal from '@leaflink/stash/Modal.vue';

  import i18n from '@/plugins/i18n';

  const emits = defineEmits<{
    (e: 'accept'): void;
    (e: 'cancel'): void;
  }>();
</script>
<template>
  <Modal :title="i18n.t('paymentOnSellThroughEnrollment.terms.title')">
    <div class="tw-min-h-[487px]">
      <div class="tw-text-center">
        <Illustration type="spot" name="data" :size="100" class="tw-mb-6" />
      </div>
      <Divider class="tw-text-lg tw-font-medium tw-normal-case tw-text-black">{{
        i18n.t('paymentOnSellThroughEnrollment.terms.subtitle')
      }}</Divider>
      <div class="tw-text-xs tw-text-center tw-mt-2 tw-mb-12">
        {{ i18n.t('paymentOnSellThroughEnrollment.terms.disclaimer') }}
      </div>
      <div
        v-html="i18n.t('termsAndConditions.accept.body1')"
        class="tw-max-h-[548px] lg:tw-max-h-64 tw-overflow-scroll tw-overflow-x-hidden tw-bg-ice-100 tw-text-ice-900 tw-p-4 tw-rounded"
      />
    </div>
    <template #actions>
      <Button secondary @click="emits('cancel')">{{ i18n.t('common.nevermind') }}</Button>
      <Button @click="emits('accept')">{{ i18n.t('common.accept') }}</Button>
    </template>
  </Modal>
</template>
